import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import { errorConditionGTM } from "../../../Utils/googleTags";
import ApiUrls from "../../../Utils/axr";

type accountSettingContentDetailsInitialStateType = {
  accountSettingPageContent: any;
  loading: boolean;
  error: any;
};
const initialState: accountSettingContentDetailsInitialStateType = {
  accountSettingPageContent: null,
  loading: false,
  error: null,
};
const host = window?.location?.host;
const file = "account-settings-page.json";

export const getAccountSettingPageContent = createAsyncThunk(
  "get/accountSetting-page/content",
  async () => {
    try {
      const response = await useFetchAemBrspdContents({
        [ApiUrls.aem_content]: `${file}?appName=${host}`,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

const accountSettingContentDetailSlice = createSlice({
  name: "accountSetting-page/Details",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAccountSettingPageContent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAccountSettingPageContent.fulfilled, (state, action) => {
      state.accountSettingPageContent = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getAccountSettingPageContent.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "Account setting content",
        action.error?.message,
        action?.type
      );
      state.accountSettingPageContent = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});

export default accountSettingContentDetailSlice.reducer;
